import { EditingPermissions } from "./editing-permissions";
import { PosterProject } from "./poster-project";

export interface ProjectTemplate {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  project: PosterProject;
  thumbnail: string;
  name: string;
  description: string;
  appliedElements: ProjectTemplateAppliedElements;
  editingPermissions: EditingPermissions;
}

export interface ProjectTemplateAppliedElements {
  mapStyle: boolean;
  mapCoordinates: boolean;
  posterSize: boolean;
  borderStyle: boolean;
  pointStyle: boolean;
  lineStyle: boolean;
  mapLabelStyle: boolean;
  staticLabelStyle: boolean;
  backdropStyle: boolean;

  routeCoordinates: boolean;
  styledPoints: boolean;
  backdrops: boolean;
  mapLabels: boolean;
  staticLabels: boolean;
}

export const applyTemplateToProject = (
  template: ProjectTemplate,
  project: PosterProject
): PosterProject => {
  const newProject = project;
  const templateProject = template.project;

  const appliedElements = template.appliedElements;

  newProject.name = template.name;

  if (appliedElements.mapStyle) {
    newProject.mapStyle = templateProject.mapStyle;
  }
  if (appliedElements.mapCoordinates) {
    if (templateProject.bounds) {
      newProject.bounds = { ...templateProject.bounds };
    }
  }
  if (appliedElements.posterSize) {
    newProject.size = templateProject.size;
  }
  if (appliedElements.borderStyle) {
    newProject.borderStyle = { ...templateProject.borderStyle };
  }
  if (appliedElements.pointStyle) {
    newProject.pointStyle = { ...templateProject.pointStyle };
  }
  if (appliedElements.lineStyle) {
    newProject.lineStyle = { ...templateProject.lineStyle };
  }
  if (appliedElements.mapLabelStyle) {
    newProject.mapLabelStyle = { ...templateProject.mapLabelStyle };
  }
  if (appliedElements.staticLabelStyle) {
    newProject.staticLabelStyle = { ...templateProject.staticLabelStyle };
  }
  if (appliedElements.backdropStyle) {
    newProject.backdropStyle = { ...templateProject.backdropStyle };
  }

  if (appliedElements.routeCoordinates) {
    newProject.gpsSourceIDs = templateProject.gpsSourceIDs.map((id) => id);
  }

  if (appliedElements.styledPoints) {
    newProject.styledPoints = templateProject.styledPoints.map((point) => ({
      ...point,
      editingPermissions: point.editingPermissions
        ? { ...point.editingPermissions }
        : undefined,
    }));
  }
  if (appliedElements.backdrops) {
    newProject.backdrops = templateProject.backdrops.map((backdrop) => ({
      ...backdrop,
      editingPermissions: backdrop.editingPermissions
        ? { ...backdrop.editingPermissions }
        : undefined,
    }));
  }

  newProject.mapLabels = templateProject.mapLabels.map((label) => ({
    ...label,
    editingPermissions: label.editingPermissions
      ? { ...label.editingPermissions }
      : undefined,
  }));

  if (appliedElements.staticLabels) {
    newProject.staticLabels = templateProject.staticLabels.map((label) => ({
      ...label,
      editingPermissions: label.editingPermissions
        ? { ...label.editingPermissions }
        : undefined,
    }));
  }

  console.log(
    "New project with editing permisions for labels = " +
      template.editingPermissions.point.size
  );
  newProject.editingPermissions = { ...template.editingPermissions };

  return newProject;
};
